var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrievanceMobMiddleLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 309,
    height: 2,
    viewBox: "0 0 309 2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.163024 1L1 1.83698L1.83698 1L1 0.163024L0.163024 1ZM308.837 1L308 0.163024L307.163 1L308 1.83698L308.837 1ZM1 1.14497H308V0.855031H1V1.14497Z",
    fill: "#094E8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrievanceMobMiddleLine);
export default __webpack_public_path__ + "static/media/grievance-mob-middle-line.535187b3850b91e64f268962d70fb3aa.svg";
export { ForwardRef as ReactComponent };